import React, { Component } from 'react';
import _ from 'lodash';

class LoginPageSettingSection extends Component {
  constructor(props){
    super(props);
  }

  render(){
    return(
      <div>
        <h3>ตั้งค่าหน้า Login</h3>
        <div className="mb-2 row">
          <label htmlFor="login_text" className="col-sm-2 col-form-label">
            ข้อความใต้ปุ่มเข้าสู่ระบบ
          </label>
          <div className="col-sm-10">
            <input 
              type='text' 
              name="login_text" 
              value={this.props.login_text} 
              onChange={this.props.onUpdateSiteSetting} 
              className='form-control form-control-sm' />
          </div>
        </div>
      </div>
    )
  }
}

export default LoginPageSettingSection;



// WEBPACK FOOTER //
// ./src/components/settings/LoginPageSettingSection.js